"use client";
import Image from "next/image";
import { useEffect, useState } from "react";

import useStore from "../../../lib/Store/useStore";
import { LoadingWhiteSpinner } from "../../../public/Theme";
import { getFlagEmoji } from "../../../utils/countryUtils";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import { useCountryData } from "../../CustomHooks/useCountriesData";
import { CONFIRM_COUNTRY_TEXT } from "./constant";

const CountrySelectionPopup = () => {
    const {
        flag: countryStoreFlag,
        triggeredGeoIP2,
        showCountrySelectionPopUp,
    } = useStore();

    const [showModal, setShowModal] = useState(false);

    const {
        selectedCountry,
        setSelectedCountry,
        countriesRates,
        flag,
        setFlag,
        handleCountryChange,
    } = useCountryData();

    useEffect(() => {
        setShowModal(triggeredGeoIP2);
    }, [triggeredGeoIP2]);

    useEffect(() => {
        if (countryStoreFlag) {
            setSelectedCountry(countryStoreFlag);
            setFlag(getFlagEmoji(countryStoreFlag));
        }
    }, [countryStoreFlag]);

    const handleModalConfirm = () => {
        showCountrySelectionPopUp(false);
        setShowModal(false);
    };

    if (!showModal) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-40">
            <div className="bg-white rounded-2xl p-6 sm:p-8 w-full max-w-md shadow-lg">
                <TypographyMontserrat
                    fontWeight="normal"
                    size="md"
                    align="center"
                    text={CONFIRM_COUNTRY_TEXT}
                    customStyle="mt-3"
                />

                <div className="mt-4">
                    <select
                        onChange={(e) => handleCountryChange(e.target.value)}
                        value={selectedCountry || ""}
                        className="w-full px-4 py-3 border rounded-lg text-gray-700 focus:ring focus:ring-black"
                    >
                        <option key="default" value="" disabled>
                            Select Your Country
                        </option>
                        {countriesRates?.map((c) => (
                            <option key={c?.country} value={c?.iso_alpha_2}>
                                {c?.country}
                            </option>
                        ))}
                    </select>
                </div>

                {flag ? (
                    <span className="text-4xl flex items-center justify-center mt-5">
                        {flag}
                    </span>
                ) : (
                    <Image
                        src={LoadingWhiteSpinner}
                        width={31}
                        height={30}
                        alt="processing gif"
                        className="mx-auto mt-5"
                    />
                )}

                <button
                    onClick={handleModalConfirm}
                    className="w-full bg-black text-white py-3 rounded-lg mt-6 hover:bg-gray-900 transition"
                >
                    Confirm Selection
                </button>
            </div>
        </div>
    );
};

export default CountrySelectionPopup;
